import { Phone, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import tedsLogo from '@/assets/teds-logo-transparent.png';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-primary text-primary-foreground py-12">
      <div className="container-custom">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Logo */}
          <div>
            <Link to="/">
              <img src={tedsLogo} alt="Ted's Shades & Shutters" className="h-14 w-auto" width={100} height={56} loading="lazy" />
            </Link>
            <p className="mt-4 text-sm text-primary-foreground/70">
              Family-owned and operated, serving Phoenix since 1994.
            </p>
          </div>

          {/* Quick Links */}
          <nav className="flex flex-wrap gap-6 justify-center">
            <a href="/" className="text-sm hover:text-primary-foreground/80 transition-colors">Home</a>
            <a href="/#products" className="text-sm hover:text-primary-foreground/80 transition-colors">Products</a>
            <a href="/#about" className="text-sm hover:text-primary-foreground/80 transition-colors">About</a>
            <a href="/#contact" className="text-sm hover:text-primary-foreground/80 transition-colors">Contact</a>
          </nav>

          {/* Contact & Social */}
          <div className="flex flex-col md:items-end gap-4">
            <a href="tel:6026914066" className="flex items-center gap-2 text-sm hover:text-primary-foreground/80 transition-colors">
              <Phone className="w-4 h-4" />
              602.691.4066
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:text-primary-foreground/80 transition-colors">
              <Instagram className="w-4 h-4" />
              Follow Us
            </a>
          </div>
        </div>

        <hr className="my-8 border-primary-foreground/10" />

        {/* Google Maps & Business Info */}
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.4092694146134!2d-112.22809819999999!3d33.6983572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b678e424c2b23%3A0x563b736f936a2a8!2sTed&#39;s%20Shades%20and%20Shutters!5e0!3m2!1sen!2sus!4v1775086502825!5m2!1sen!2sus"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ted's Shades & Shutters Location"
            />
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="font-display text-xl font-semibold text-primary-foreground">
              Ted's Shades & Shutters
            </h3>
            <a
              href="tel:6026914066"
              className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
            >
              602.691.4066
            </a>
            <p className="text-primary-foreground/80">
              7850 W Camino De Oro, Peoria, AZ 85383
            </p>
          </div>
        </div>

        <hr className="my-8 border-primary-foreground/10" />

        {/* SEO Footer Content */}
        <div className="text-center space-y-2 mb-8">
          <p className="text-base font-semibold text-primary-foreground">
            Ted's Shades & Shutters | Custom Window Treatments in Peoria, AZ
          </p>
          <p className="text-sm text-primary-foreground/80">
            Serving Peoria, Phoenix, Glendale, Surprise & Surrounding Areas
          </p>
          <p className="text-sm text-primary-foreground/80">Free Same Day Estimates</p>
        </div>

        <div className="text-center text-sm text-primary-foreground/60">
          © {currentYear} Ted's Shades and Shutters. All rights reserved.
        </div>
      </div>
    </footer>;
}